import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Store from '../store/Store';

const TaskCard = ({ task, isNebihSendable, statusIcons, isCompleted, tableName, redirectToTable, isOpen, toggleTaskState }) => {

    let {parcels} = Store.getState();

    // Ha több table_id is van, azt itt most az első alapján kezeljük
    const taskTableId = task.table_id[0]; // vagy task.table_id ha több kell
    // Összes parcella, ami ehhez a táblához tartozik
    const parcelsForTable = parcels.filter(p => p.table_id === taskTableId);
    // Érintett parcellák: amik benne vannak a task.parcels tömbben
    const affectedParcels = parcelsForTable.filter(p => task.parcels.includes(p.id));
    // Nem érintett parcellák: amik ugyan ebbe a táblához tartoznak, de nem szerepelnek a task.parcels-ben
    const unaffectedParcels = parcelsForTable.filter(p => !task.parcels.includes(p.id));    

    return(
    <Col key={'task_' + task.id} xs={12} md={6} lg={4}>
        <Card border="light" className="mb-2 task">
            <Card.Header 
                className={`d-flex justify-content-between align-items-center ${!isOpen ? "round" : ""}`}
                onClick={() => toggleTaskState(task.id)}
            >
                {/* Bal oldalon ikon és név */}
                <div className="d-flex align-items-start">
                    {/* Bal oldalon FontAwesome ikon */}
                    <div className="task-icon">
                        {/* <FontAwesomeIcon className={`icon ${task.editable ? 'peach' : ''}`} icon={task.completed_at ? 'check-circle' : 'seedling'} /> */}
                        <FontAwesomeIcon className={`icon`} icon={task.completed_at ? 'check-circle' : 'seedling'} />
                    </div>
                    
                    {/* Jobb oldalon a név és a dátumok */}
                    <div className="task-info">
                        <strong>{task.name}</strong>
                        { true ? <div className="task-dates"><span>{task.started_at}{task.completed_at && ` - ${task.completed_at}`}</span></div> : ""}
                    </div>
                </div>                
                {/* Jobb oldalon gomb */}
                <div className="d-flex align-items-center">
                        {/* {isNebihSendable(task)}
                        {statusIcons(task)}
                        {isCompleted(task)} */}
                        {task.notes.length > 0 ? (
                        <span className="card--envelope peach me-3">
                            <FontAwesomeIcon icon="fa-solid fa-comment-alt" />
                        </span>
                        ) : ('')}
                        <span className="btn button card--right-arrow" onClick={(e) => redirectToTable(e, "/edit-task/" + task.guid)}>
                            <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                        </span>
                </div>
            </Card.Header>
            {isOpen && (
                <Card.Body>
                    <Row>
                        <Col><span><strong>Táblacsoport</strong></span></Col>
                        <Col>
                            <span>
                                <button className={"btn-link"} onClick={(e) => redirectToTable(e, "/task/" + task.table_id)}>
                                    {tableName(task.table_id)}
                                </button>
                            </span>
                        </Col>
                    </Row>
                    <Row><Col>Aratási év</Col><Col>{task.harvest_year_name}</Col></Row>
                    <Row><Col>Terület</Col><Col>{task.task_area}</Col></Row>
                    <Row><Col>Költség/ha</Col><Col><strong>{task.task_cost}</strong></Col></Row>
                    <Row><Col>Érintett táblák</Col><Col><strong>{affectedParcels.map(p => p.parcel_name).join(', ') || '–'}</strong></Col></Row>
                    <Row><Col>Nem érintett táblák</Col><Col><strong>{unaffectedParcels.map(p => p.parcel_name).join(', ') || '–'}</strong></Col></Row>
                    <Row><Col>Státus</Col>
                            <Col>
                                <strong style={{
                                    color: (() => {
                                        const farm = Store.getState().farms.find(f => f.id === task.farm_id);
                                        const statusObj = farm?.statuses?.find(s => s.id === task.status);
                                        if (statusObj) return statusObj.color || 'black';
                                        if (task.status === 1) return 'gray';
                                        if (task.status === 2) return 'green';
                                        return 'black';
                                    })()
                                }}>
                                    {(() => {
                                        const farm = Store.getState().farms.find(f => f.id === task.farm_id);
                                        const statusObj = farm?.statuses?.find(s => s.id === task.status);
                                        if (statusObj) return statusObj.label;
                                        if (task.status === 1) return 'Piszkozat';
                                        if (task.status === 2) return 'Véglegesített';
                                        return 'Ismeretlen';
                                    })()}
                                </strong>
                            </Col>                    
                    </Row>
                  
                    {/* <Row><Col><strong>Kezdés</strong></Col><Col>{task.started_at}</Col></Row>
                    {task.completed_at && (
                        <Row><Col><strong>Befejezés</strong></Col><Col>{task.completed_at}</Col></Row>
                    )} */}
                </Card.Body>
            )}
        </Card>
    </Col>
    );
};

export default TaskCard;